import { Check } from "lucide-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import FormHeader from "../../../components/form/FormHeader";
import { Button } from "../../../components";
import { goBackOrGoHome } from "../../../utils/navigation";
import NewsForm, { type NewsFormSubmitValues } from "../components/form/NewsForm";
import { useCreateNews } from "../hooks/useCreateNews";

function CreateNewsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { createNews, loading, error, success } = useCreateNews();

  useEffect(() => {
    if (success) {
      navigate("/news", { replace: true });
    }
  }, [navigate, success]);

  const handleSubmit = async (values: NewsFormSubmitValues) => {
    await createNews({
      title: values.title.trim(),
      content: values.content.trim(),
      thumbnail_url: values.thumbnail_url,
      location: values.location?.trim() || undefined,
      thumbnail_file: values.thumbnail_file,
    });
  };

  return (
    <div className="min-h-screen bg-background">
      <FormHeader
        onBack={() => goBackOrGoHome(navigate)}
        title={t("news.create_new_news")}
        subtitle=""
        backLabel={t("common.back")}
        actions={
          <Button type="submit" form="news-create-form" disabled={loading} className="shrink-0">
            <Check className="h-4 w-4" />
            {loading ? t("news.creating") : t("news.create_news")}
          </Button>
        }
      />

      <NewsForm
        formId="news-create-form"
        loading={loading}
        error={error}
        onSubmit={handleSubmit}
      />
    </div>
  );
}

export default CreateNewsPage;
